import React from 'react';
import { SortableElement, SortableElementProps } from 'react-sortable-hoc';
import { Flex, Typography, color, Box, Icon } from '@kistech/kis-ui';

interface MediaRowProps {
  label: string;
  selected: boolean;
  cursor?: string;
  onClick: () => void;
  onEditClick?: () => void;
  onDeleteClick?: () => void;
}

export const MediaRow: React.FC<MediaRowProps> = (props: MediaRowProps) => {
  const { selected, label, cursor, onClick, onEditClick, onDeleteClick } = props;
  const rowColor = selected ? color.X_LIGHT_GRAY : color.WHITE;
  const flagColor = selected ? color.PRIMARY : color.WHITE;
  const accentColor = selected ? color.PRIMARY : color.BLACK;

  return (
    <Flex
      height={50}
      align="center"
      justify="between"
      direction="row"
      onClick={onClick}
      style={{ backgroundColor: rowColor, cursor }}
    >
      <Flex height={50} align="center">
        <Box fullHeight width={8} margin="0 3 0 0" style={{ backgroundColor: flagColor }} />
        <Typography size={18}>{label}</Typography>
      </Flex>
      <Flex margin="0 4">
        {onDeleteClick && (
          <Flex style={{ cursor: 'pointer' }} align="center" margin="0 2" onClick={onDeleteClick}>
            <Icon name="exit_circle" color={accentColor} size={24} />
          </Flex>
        )}
        {onEditClick && (
          <Flex style={{ cursor: 'pointer' }} align="center" margin="0 2" onClick={onEditClick}>
            <Icon name="edit_circle" color={accentColor} size={24} />
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const SortableRow: React.ComponentClass<SortableElementProps & MediaRowProps, any> = SortableElement(
  (props: MediaRowProps) => MediaRow(props)
);
